// @ts-nocheck

import { SportId, SportIds } from '../../../types/sports';

export const SupportedLineUpSportIds = [
  SportIds.SOCCER,
  SportIds.RUGBY,
  SportIds.RUGBY_LEAGUE,
  SportIds.BASKETBALL,
  SportIds.ICEHOCKEY,
  SportIds.FORMULA_1,
  SportIds.MOTO,
];

export const SportsWithLineUpNewTag = [SportIds.FORMULA_1, SportIds.MOTO];

export const SportsWithFixedFormation: Array<SportId> = [
  SportIds.RUGBY,
  SportIds.RUGBY_LEAGUE,
  SportIds.BASKETBALL,
  SportIds.ICEHOCKEY,
];

export const SportsWithNoTab: Array<SportId> = [SportIds.BASKETBALL];

export const SportsWithSpecialSubstitutes = [SportIds.RUGBY, SportIds.RUGBY_LEAGUE];

export const SportsWithRaceTrackUI: Array<SportId> = [SportIds.FORMULA_1, SportIds.MOTO];

export const LineUpFormationsBySportId: Record<SportId, string> = {
  [SportIds.RUGBY]: '1-4-2-3-2-3', // rugby à 15
  [SportIds.RUGBY_LEAGUE]: '1-4-2-1-2-3', // rugby à 13
  [SportIds.BASKETBALL]: '2-3-3-2', // basketball
  [SportIds.ICEHOCKEY]: '2-3-3-2', // Ice Hockey 1-2-3
};

export const LineUpFixedFormationMappingBySportId: Record<SportId, Array<number>> = {
  [SportIds.RUGBY]: [14, 13, 12, 11, 10, 9, 8, 6, 7, 5, 4, 3, 2, 1, 0],
  [SportIds.RUGBY_LEAGUE]: [0, 1, 2, 3, 4, 5, 6, 12, 10, 11, 7, 8, 9],
  [SportIds.BASKETBALL]: [7, 8, 5, 9, 6, 1, 4, 0, 3, 2],
};

export const LineUpIceHockeyFormationByLine: { [line: string]: string } = {
  '1': '2-3-3-2',
  '2': '2-3-3-2',
  '3': '2-3-3-2',
  '4': '0-3-3-0',
};

export const LineUpIceHockeyFormationMappingByLine: { [line: string]: number[] } = {
  '1': [31, 30, 20, 19, 18, 0, 1, 2, 12, 13],
  '2': [33, 32, 23, 22, 21, 3, 4, 5, 14, 15],
  '3': [35, 34, 26, 25, 24, 6, 7, 8, 16, 17],
  '4': [29, 28, 27, 9, 10, 11],
};
